module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 35 35"
    }
  }, [_c('defs'), _c('g', {
    attrs: {
      "id": "Слой_2",
      "data-name": "Слой 2"
    }
  }, [_c('g', {
    attrs: {
      "id": "Слой_1-2",
      "data-name": "Слой 1"
    }
  }, [_c('path', {
    staticClass: "cls-1",
    attrs: {
      "d": "M26,15.62c.09-.75.14-1.27.22-1.78,0-.19,0-.34-.35-.43a6.55,6.55,0,0,1-3.59-2.15C20,8.36,20,5.42,22.22,2.5a6.08,6.08,0,0,1,2-1.6,7.59,7.59,0,0,1,7.17,0A6.61,6.61,0,0,1,33.9,3.25a6.36,6.36,0,0,1-.11,7.31,6.62,6.62,0,0,1-3.86,2.76c-.42.13-.32.31-.3.5.24,2.61.5,5.23.74,7.85.33,3.71.66,7.43,1,11.14.08,1-.91,1.79-2.45,2.09a5.22,5.22,0,0,1-4-.76,1.47,1.47,0,0,1-.67-1.32Q25.07,24.9,25.93,17C26,16.45,26,15.92,26,15.62Z"
    }
  }), _c('path', {
    staticClass: "cls-1",
    attrs: {
      "d": "M14.29,6.56c0,1.8,0,3.59,0,5.39,0,.54-.36.84-1.15,1.05a23,23,0,0,1-3,.5c-1.19.14-1.19.14-1.13.86l.78,8.19q.44,4.72.86,9.45A2.45,2.45,0,0,1,9.2,34.45a4.05,4.05,0,0,1-4.12,0A2.4,2.4,0,0,1,3.66,32q.86-7.76,1.73-15.5c.08-.73.16-1.45.18-2.18s-.12-.71-1.17-.81A17.43,17.43,0,0,1,1,13c-.65-.18-1-.44-1-.9C0,8.42,0,4.71,0,1,0,.35.55,0,1.48,0S2.9.37,2.91,1V8.76A1.47,1.47,0,0,0,3,9.53a1.16,1.16,0,0,0,1.11.56,1.45,1.45,0,0,0,1.29-.5,1.43,1.43,0,0,0,.2-.91c0-2.58,0-5.15,0-7.72,0-.7.53-1,1.68-.95.91,0,1.32.32,1.32,1V8.79a1.2,1.2,0,0,0,.25.85,1.51,1.51,0,0,0,1.2.44,1.27,1.27,0,0,0,1.12-.5,1.4,1.4,0,0,0,.18-.86c0-2.56,0-5.11,0-7.67A.8.8,0,0,1,12,.15a2.47,2.47,0,0,1,1.59,0c.55.17.71.47.71.82Z"
    }
  })])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1129c5c6","hasScoped":false,"preserveWhitespace":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/uikit/components/AppSvgIcon/iconsTemplate/contents/appetite.vue
// module id = a481efee587e9b7e8e62
// module chunks = 89